import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import YouTubeIcon from "@mui/icons-material/YouTube";

// Social icons
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Modal, Form } from 'react-bootstrap';

// Logo image
import loggo from '../img/logonew.jpg';
import { FaTiktok } from 'react-icons/fa';

const Header = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Input change handler
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Submit handler (single version only)
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://swiftkey.co.ke/sendmail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      alert(data.message);

      if (data.status === "success") {
        setFormData({ name: "", email: "", phone: "", message: "" });
        setShowModal(false); // close modal after success
      }
    } catch (err) {
      alert("Failed to send enquiry. Try again later.");
    }
  };

  const isActive = (path) => (currentPath === path ? 'active' : '');

  const handleNavLinkClick = () => {
    setIsNavOpen(false);
    setIsDropdownOpen(false);
  };

  // Detect scroll to toggle fixed header
  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Topbar */}
      <div className="container-fluid bg-dark px-0">
        <div className="row g-0 d-none d-lg-flex">
          <div className="col-lg-6 ps-5 text-start">
            <div className="h-100 d-inline-flex align-items-center text-white">
              <span>Follow Us:</span>
              <a
                className="btn btn-link text-light"
                href="https://www.tiktok.com/@swiftkeydevelopmentltd"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok color="white" />
              </a>
              <a className="btn btn-link text-light" href="https://www.facebook.com/profile.php?id=61583828638745" target="_blank" rel="noopener noreferrer"><FacebookIcon /></a>
              {/* <a className="btn btn-link text-light" href="https://twitter.com" target="_blank" rel="noopener noreferrer"><TwitterIcon /></a> */}
              <a className="btn btn-link text-light" href="https://www.linkedin.com/company/swiftkey-development-ltd/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a>
              <a
                className="btn btn-link text-light"
                href="https://youtube.com/@swiftkeydevelopmentlimited?si=na9gk9vQlfsGvXrN" target="_blank" rel="noopener noreferrer"
              >
                <YouTubeIcon style={{ color: "white" }} />
              </a>
              <a
                className="btn btn-link text-light"
                href="https://www.instagram.com/swiftkeydevelopmentltd/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon style={{ color: "white" }} />
              </a>
            </div>
          </div>
          <div className="col-lg-6 text-end">
            <div className="h-100 topbar-right d-inline-flex align-items-center text-white py-2 px-5">
              <span className="fs-5 fw-bold me-2"><i className="fa fa-phone-alt me-2" /> Call Us:</span>
              <span className="fs-5 fw-bold">| +254 708 022458</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className={`navbar navbar-expand-lg bg-white navbar-light shadow-sm py-0 pe-3 ${isScrolled ? 'fixed-top' : 'sticky-top'}`}>
        <Link to="/" className="navbar-brand ps-3 me-0" onClick={handleNavLinkClick}>
          <img src={loggo} alt="Equipment Logo" className="header-logo" style={{ height: "70px", width: "252px" }} />
        </Link>

        <button
          type="button"
          className="navbar-toggler me-0"
          aria-controls="main-navbar"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsNavOpen(!isNavOpen)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`collapse navbar-collapse${isNavOpen ? ' show' : ''}`} id="main-navbar">
          <div className="navbar-nav ms-auto p-3 p-lg-0">
            <Link to="/" className={`nav-item nav-link ${isActive('/')}`} onClick={handleNavLinkClick}>Home</Link>

            {/* About dropdown */}
            <div
              className={`nav-item dropdown${isAboutOpen ? ' show' : ''}`}
              onMouseEnter={() => setIsAboutOpen(true)}
              onMouseLeave={() => setIsAboutOpen(false)}
              role="presentation"
            >
              <span
                className="nav-link dropdown-toggle"
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', userSelect: 'none' }}
                onClick={() => setIsAboutOpen(!isAboutOpen)}
              >
                About
                <ExpandMoreIcon
                  style={{
                    marginLeft: 5,
                    verticalAlign: 'middle',
                    transition: 'transform 0.3s',
                    transform: isAboutOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </span>
              <div className={`dropdown-menu bg-light m-0${isAboutOpen ? ' show' : ''}`}>
                <Link to="/about" className="dropdown-item" onClick={handleNavLinkClick}>About Us</Link>
                <a
                  href="/assets/my-profile.pdf"
                  className="dropdown-item"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleNavLinkClick}
                >
                  My Profile
                </a>
              </div>
            </div>

            {/* Services dropdown */}
            <div
              className={`nav-item dropdown${isServicesOpen ? ' show' : ''}`}
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
              role="presentation"
            >
              <span
                className="nav-link dropdown-toggle"
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', userSelect: 'none' }}
                onClick={() => setIsServicesOpen(!isServicesOpen)}
              >
                Services
                <ExpandMoreIcon
                  style={{
                    marginLeft: 5,
                    verticalAlign: 'middle',
                    transition: 'transform 0.3s',
                    transform: isServicesOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                />
              </span>
              <div className={`dropdown-menu bg-light m-0${isServicesOpen ? ' show' : ''}`}>
                <Link to="/construction" className="dropdown-item" onClick={handleNavLinkClick}>Construction</Link>
                <Link to="/maintenance" className="dropdown-item" onClick={handleNavLinkClick}>Maintenance Support</Link>
                <Link to="/after-sales" className="dropdown-item" onClick={handleNavLinkClick}>After Sales Service</Link>
                <Link to="/metal-fitout" className="dropdown-item" onClick={handleNavLinkClick}>Metal Fit-Out</Link>
                <Link to="/contracting-construction" className="dropdown-item" onClick={handleNavLinkClick}>Contracting & Construction</Link>
                <Link to="/metal" className="dropdown-item" onClick={handleNavLinkClick}>Metal Fabrication</Link>
                <Link to="/civil" className="dropdown-item" onClick={handleNavLinkClick}>Civil Construction</Link>
                <Link to="/fit-out" className="dropdown-item" onClick={handleNavLinkClick}>Fit-Out Services</Link>
              </div>
            </div>
            {/* <Link to="/construction" className={`nav-item nav-link ${isActive('/construction')}`} onClick={handleNavLinkClick}>Construction</Link> */}

            <Link to="/client" className={`nav-item nav-link ${isActive('/client')}`} onClick={handleNavLinkClick}>Client</Link>
            <Link to="/recent-projects" className={`nav-item nav-link ${isActive('/recent-projects')}`} onClick={handleNavLinkClick}>Our Project</Link>
            <Link to="/whyus" className={`nav-item nav-link ${isActive('/whyus')}`} onClick={handleNavLinkClick}>Why Us</Link>

            <Link to="/our-strength" className={`nav-item nav-link ${isActive('/our-strength')}`} onClick={handleNavLinkClick}>Our Strength</Link>
            <Link to="/contact" className={`nav-item nav-link ${isActive('/contact')}`} onClick={handleNavLinkClick}>Contact</Link>
          </div>

          <button
            className="btn btn-primary px-3 d-none d-lg-block"
            onClick={() => setShowModal(true)}
          >
            Get A Quote
          </button>

          {/* Modal Form */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Enquiry Form</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleFormSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="name@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    placeholder="Enter phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    placeholder="Tell us more..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  Submit Enquiry
                </Button>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      </nav>
    </>
  );
};

export default Header;
